import React from "react";
import {color} from "common/tokens";

const ProgressRing = ({
  progress = 0,
  size = 33,
  strokeWidth = 3.5,
  fill = color.RING_FILL,
  track = color.RING_TRACK,
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.max(0, Math.min(1, progress));

  return (
    <svg width={size} height={size} style={{display: 'block', flexShrink: 0}}>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={track}
        strokeWidth={strokeWidth}
        fill={'none'}
      />
      {clamped > 0 && (
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap={'round'}
          fill={'none'}
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={circumference * (1 - clamped)}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      )}
    </svg>
  );
};

export default ProgressRing;
